<template>
  <el-dialog
    :visible.sync="visible"
    :title="announcement ? announcement.title : '系统公告'"
    :width="dialogWidth"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    center
    class="announcement-popup"
    :class="`announcement-${announcement ? announcement.type : 'info'}`">
    
    <div v-if="announcement" class="announcement-popup-content">
      <!-- 公告图标 -->
      <div class="announcement-popup-icon">
        <i :class="getIconClass(announcement.type)"></i>
      </div>
      
      <!-- 公告内容 -->
      <div class="announcement-popup-body">
        <h3 class="announcement-popup-title">{{ announcement.title }}</h3>
        <div class="announcement-popup-text" v-html="formatContent(announcement.content)"></div>
      </div>
    </div>

    <div slot="footer" class="announcement-popup-footer">
      <el-button type="primary" @click="confirmRead" size="medium">
        我知道了
      </el-button>
      <!-- 移除"今日不再提醒"选项 - 每次登录都要弹出 -->
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'AnnouncementPopup',
  data() {
    return {
      visible: false,
      announcement: null
    }
  },
  computed: {
    dialogWidth() {
      // 响应式宽度
      if (window.innerWidth <= 480) {
        return '90%'
      } else if (window.innerWidth <= 768) {
        return '80%'
      } else {
        return '500px'
      }
    }
  },
  async mounted() {
    await this.checkAndShowAnnouncement()
  },
  methods: {
    async checkAndShowAnnouncement() {
      try {
        // 检查当前会话是否已经显示过弹窗
        const currentToken = localStorage.getItem('token')
        const lastShownToken = sessionStorage.getItem('announcementShownForToken')
        
        if (currentToken && lastShownToken === currentToken) {
          // 当前会话已经显示过弹窗，不再显示
          console.log('当前会话已显示过弹窗，跳过')
          return
        }
        
        // 获取当前用户类型
        const userType = this.getUserType()
        
        const response = await this.$http.get(`/api/announcements/popup?userType=${userType}`)
        
        if (response && response.success && response.data) {
          this.announcement = response.data
          this.visible = true
          
          // 记录当前token，表示已为此会话显示过弹窗
          if (currentToken) {
            sessionStorage.setItem('announcementShownForToken', currentToken)
          }
        }
      } catch (error) {
        console.error('加载弹窗公告失败:', error)
      }
    },

    getUserType() {
      const currentPath = this.$route.path
      if (currentPath.startsWith('/admin')) {
        return 'admin'
      } else if (currentPath.startsWith('/worker')) {
        return 'worker'
      } else {
        return 'customer'
      }
    },

    getIconClass(type) {
      const iconMap = {
        'info': 'el-icon-info',
        'warning': 'el-icon-warning',
        'success': 'el-icon-success',
        'error': 'el-icon-error'
      }
      return iconMap[type] || 'el-icon-info'
    },

    formatContent(content) {
      // 将换行符转换为<br>标签
      return content.replace(/\n/g, '<br>')
    },

    confirmRead() {
      this.visible = false
      // 移除本地存储逻辑 - 每次登录都要弹出
    }
  }
}
</script>

<style scoped>
/* 弹窗基础样式 */
.announcement-popup >>> .el-dialog {
  border-radius: 12px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.announcement-popup >>> .el-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 25px;
  margin: 0;
}

.announcement-popup >>> .el-dialog__title {
  color: white;
  font-weight: 600;
  font-size: 18px;
}

.announcement-popup >>> .el-dialog__body {
  padding: 25px;
}

.announcement-popup-content {
  display: flex;
  align-items: flex-start;
  text-align: left;
}

.announcement-popup-icon {
  font-size: 48px;
  margin-right: 20px;
  flex-shrink: 0;
  margin-top: 5px;
}

.announcement-popup-body {
  flex: 1;
}

.announcement-popup-title {
  margin: 0 0 15px 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}

.announcement-popup-text {
  font-size: 15px;
  line-height: 1.6;
  color: #606266;
  margin-bottom: 0;
}

.announcement-popup-footer {
  text-align: center;
  padding-top: 10px;
}

/* 移除提示样式 - 不再需要"今日不再提醒" */

/* 不同类型的公告样式 */
.announcement-info .announcement-popup-icon {
  color: #409EFF;
}

.announcement-warning .announcement-popup-icon {
  color: #E6A23C;
}

.announcement-success .announcement-popup-icon {
  color: #67C23A;
}

.announcement-error .announcement-popup-icon {
  color: #F56C6C;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .announcement-popup >>> .el-dialog__header {
    padding: 15px 20px;
  }

  .announcement-popup >>> .el-dialog__title {
    font-size: 16px;
  }

  .announcement-popup >>> .el-dialog__body {
    padding: 20px;
  }

  .announcement-popup-content {
    flex-direction: column;
    text-align: center;
  }

  .announcement-popup-icon {
    font-size: 40px;
    margin-right: 0;
    margin-bottom: 15px;
    margin-top: 0;
  }

  .announcement-popup-title {
    font-size: 18px;
    margin-bottom: 12px;
  }

  .announcement-popup-text {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .announcement-popup >>> .el-dialog__header {
    padding: 12px 15px;
  }

  .announcement-popup >>> .el-dialog__title {
    font-size: 15px;
  }

  .announcement-popup >>> .el-dialog__body {
    padding: 15px;
  }

  .announcement-popup-icon {
    font-size: 36px;
    margin-bottom: 12px;
  }

  .announcement-popup-title {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .announcement-popup-text {
    font-size: 13px;
  }

  /* 移除移动端提示样式 */
}

/* 动画效果 */
.announcement-popup >>> .el-dialog {
  animation: popupFadeIn 0.3s ease-out;
}

@keyframes popupFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>